$(function () {
  const range = $('.js-range');
	createRangeSlider(range)

	$('.range-input').on('keydown', function (e) {
		if (e.key.length == 1 && e.key.match(/[^0-9'".]/)) {
			return false;
		};
	})

	function createRangeSlider(range) {
		if (!range.length) return;
		const rangeInput = range.find('.range-input');
		const clean = num => num.toString().replace(/[^0-9]/g, '')
		const bitDepth = str => str.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
		const formatter = that => that.val(bitDepth(clean(that.val())))
		const useInput = input => [input.val(), input.data('max'), input.data('min'),]

		rangeInput.on('change', e => {
			const input = $(e.target);
			const keyCode = e.keyCode
			const [value, maxVal, minVal] = useInput(input)
			const rangeLimit = () => +clean(value) < +minVal && keyCode !== 8 ? minVal : +clean(value) > +maxVal && keyCode !== 8 ? maxVal : value
			input.filter('.range-input-min').val(rangeLimit())
			input.filter('.range-input-max').val(rangeLimit())
			formatter(input)
		});

		rangeInput.each((_, r) => formatter($(r)))

		const useFields = range => [range.find('.range-input-min'), range.find('.range-input-max'), range.find('.range-slider')[0]]
		const useRange = (min, max) => {
			const maxVal = !max.val() || max.val() === '0' ? max.data('max') : max.val()
			return [
				{ val: +clean(min.val()), min: +min.data('min'), max: +min.data('max') },
				{ val: +clean(maxVal), min: +max.data('min'), max: +max.data('max') }
			]
		}

		range.each((_, range) => {
			const $that = $(range)
			const [$min, $max, slider] = useFields($that)
			const [from, to] = useRange($min, $max)
			noUiSlider.create(slider, {
				start: [from.val, to.val],
				connect: true,
				// tooltips: {
				// 	to: num => bitDepth(clean(Math.round(num)))
				// },

				format: {
					from: Number,
					to: val => bitDepth(clean(Math.round(val)))
				},
				range: {
					'min': from.min,
					'max': to.max
				}
			})

			slider.noUiSlider.on('update', (val, handle)=> {
				const value = val[handle]
				if (handle === 0) {
					const slideLimit = clean(+clean(value) > from.max ? from.max : value)
					// slider.noUiSlider.set([slideLimit, null])
					$min.val(bitDepth(slideLimit)).trigger('update')
				}
				if (handle === 1) {
					const slideLimit = clean(+clean(value) < to.min ? to.min : value)
					// slider.noUiSlider.set([null, slideLimit])
					$max.val(bitDepth(slideLimit)).trigger('update')
				}
			})

			slider.noUiSlider.on('change', (val, handle)=> {
				const value = val[handle]
				if (handle === 0) {
					const slideLimit = clean(+clean(value) > from.max ? from.max : value)
					slider.noUiSlider.set([slideLimit, null])
					$min.val(bitDepth(slideLimit)).trigger('change')
				}
				if (handle === 1) {
					const slideLimit = clean(+clean(value) < to.min ? to.min : value)
					slider.noUiSlider.set([null, slideLimit])
					$max.val(bitDepth(slideLimit)).trigger('change')
				}
			})

			$min.on('change', e=> slider.noUiSlider.set([clean(e.target.value), null]))
			$max.on('change', e=> slider.noUiSlider.set([null, clean(e.target.value)]))
		});
	}
})